import React, { useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseSettingPage.module.scss'

import CommonHeader from '@Components/atoms/CommonHeader'
import CommonLayout from '@Components/atoms/CommonLayout'
import MyhouseSettingList from '@Components/modules/MyhouseSettingList'
import IconAdd25x25 from '@Root/ui/images/myhouse/IconAdd25x25.svg'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import useSetting from '@Hooks/myhouse/setting/useSetting'
import useModal from '@Hooks/myhouse/useModal'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { MyhouseLabelType } from '@Root/utils/houseLabelUtils'
import { FETCH_STATUS } from '@Root/contants'
import { NCLICK, NDS_PROTOCOL } from '@Root/contants/lcs'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { lcsSend } from '@Helpers/lcs'
import { MYHOUSE_MAX_COUNT } from '@Root/contants/myhouseRegister'

const cx = className.bind(style)

const MyhouseSettingPage: React.FC = () => {
  const { loadReorderHouse, reduxSetting } = useSetting()
  const { houseLabel, fetchStatusReorder, statusReorder } = reduxSetting
  const { open } = useModal()

  const handleAddClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    handleNclick(NCLICK.MY_HOUSE.SETTING.ADD, e)

    if (houseLabel.length >= MYHOUSE_MAX_COUNT) {
      open(MODAL_TYPE.MYHOUSE_LIMITED_NO_ROUTE, {
        nclickCancel: NCLICK.MY_HOUSE.SETTING.POPUP.ADD_LIMIT,
      })
      e.preventDefault()
    }
  }

  const handleDoneClick = (e: React.SyntheticEvent) => {
    e.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.SETTING.COMPLETE, e)

    if (statusReorder === FETCH_STATUS.SUCCESS) {
      const myHouse = houseLabel.map((house: MyhouseLabelType, index: number) => {
        const myHouseNo = house.houseNo
        const myHouseOrder = index
        return { myHouseNo, myHouseOrder }
      })
      loadReorderHouse(myHouse)
    } else {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}`
    }
  }

  const toMain = () => {
    window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}`
  }

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.HOME.SETTING)
  }, [])

  useEffect(() => {
    fetchStatusReorder === FETCH_STATUS.SUCCESS && toMain()
  }, [fetchStatusReorder])

  return (
    <>
      <CommonHeader title="우리집 추가 및 삭제" prevButton={true} textButton={true} buttonText="완료" onClickTextButton={handleDoneClick} />
      <CommonLayout>
        <div className={cx('supervise_list')}>
          <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address`} className={cx('link_add')} onClick={(e) => handleAddClick(e)}>
            <span className={cx('text')}>
              <IconAdd25x25 />
              우리집 추가하기
            </span>
          </a>
          <MyhouseSettingList />
        </div>
        <div className={cx('guide')}>
          <p className={cx('text')}>우리집은 최대 {MYHOUSE_MAX_COUNT}개까지 등록할 수 있습니다.</p>
        </div>
        <div className={cx('termination')}>
          <a
            href={`${process.env.REACT_APP_LAND_WEB_URL}/myhouse/settings/withdrawal`}
            className={cx('link_termination')}
            onClick={handleNclickMix(NCLICK.MY_HOUSE.SETTING.WITHDRAWAL)}
          >
            우리집 서비스 해지하기
          </a>
          <p className={cx('text')}>서비스를 해지하시면 우리집 등록 시 동의한 약관이 철회되며 등록한 우리집 정보가 모두 삭제됩니다.</p>
        </div>
      </CommonLayout>
    </>
  )
}

export default MyhouseSettingPage
